var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'notification-permission': true, show: this.$store.state.notificationPermission.show}},[_c('span',[_vm._v("Please enable notification for Backoffice.")]),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"href":"javascript:;"},on:{"click":_vm.showNotificationPermission}},[_vm._v("ENABLE")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be7c75f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App/NotificationPermission.vue
// module id = 839
// module chunks = 0